import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePublicPageSettings } from '../../shared/hooks';
import { PageTitle, PageTitleIconPrefix, Icons, PublicPageWrapper } from '../../shared/components';
import { CookieCompliance } from '../components';

const CookieCompliancePage: FC = () => {
  const { t } = useTranslation();
  const [, setPublicPageSettings] = usePublicPageSettings();
  useEffect(() => {
    setPublicPageSettings({ pageWidth: '42rem' });
  }, [setPublicPageSettings]);

  return (
    <PublicPageWrapper>
      <PageTitle prefix={<PageTitleIconPrefix icon={Icons.USER} />}>
        {t('security.cookieCompliance.pageTitle')}
      </PageTitle>
      <CookieCompliance />
    </PublicPageWrapper>
  );
};

export default CookieCompliancePage;
